const flexsdkSidebarButtons = {
	profilePicture: 'Profil billede & skift billede',
	sendActivateLink: 'Send aktiveringslink',
	addCustomer: 'Tilføj kunde til bon'
};

export default flexsdkSidebarButtons;
